<template>
  <v-autocomplete
    v-model="selectedIds"
    :items="displayItems"
    :loading="loading"
    item-text="description"
    item-value="osm_id"
    :label="label"
    :placeholder="placeholder"
    multiple
    chips
    deletable-chips
    small-chips
    clearable
    outlined
    dense
    hide-details
    hide-no-data
    no-filter
    :search-input.sync="search"
    cache-items
    @change="onSelectionChange"
  ></v-autocomplete>
</template>

<script>
import { computed, ref, watch } from '@vue/composition-api'
import cityService from '@/store/services/cityService'

export default {
  name: 'MemberCityFilterInput',

  props: {
    value: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: 'Villes',
    },
    placeholder: {
      type: String,
      default: 'Rechercher une ville...',
    },
  },

  setup(props, { emit }) {
    const loading = ref(false)
    const search = ref(null)
    const selectedIds = ref([...(props.value || [])])
    const cachedItems = ref([])
    const searchResults = ref([])
    let searchTimer = null

    const displayItems = computed(() => {
      const map = new Map()

      cachedItems.value.forEach(item => {
        map.set(item.osm_id, item)
      })

      searchResults.value.forEach(item => {
        map.set(item.osm_id, item)
      })

      return Array.from(map.values())
    })

    const syncCachedItems = ids => {
      ids.forEach(id => {
        const item = displayItems.value.find(entry => entry.osm_id === id)

        if (item && !cachedItems.value.find(entry => entry.osm_id === id)) {
          cachedItems.value.push(item)
        }
      })

      cachedItems.value = cachedItems.value.filter(item => ids.includes(item.osm_id))
    }

    const onSelectionChange = ids => {
      const nextIds = ids || []
      selectedIds.value = nextIds
      syncCachedItems(nextIds)
      emit('input', [...nextIds])
    }

    watch(() => props.value, value => {
      const nextIds = [...(value || [])]
      selectedIds.value = nextIds
      syncCachedItems(nextIds)
    }, { deep: true, immediate: true })

    watch(search, query => {
      if (searchTimer) {
        clearTimeout(searchTimer)
      }

      const trimmed = query ? String(query).trim() : ''

      if (!trimmed) {
        searchResults.value = []
        return
      }

      searchTimer = setTimeout(() => {
        loading.value = true

        cityService.searchCity({ city: trimmed }).then(response => {
          searchResults.value = response.data.result || []
        }).finally(() => {
          loading.value = false
        })
      }, 500)
    })

    return {
      loading,
      search,
      selectedIds,
      displayItems,
      onSelectionChange,
    }
  },
}
</script>
